import { quantile as quantileD3, mean as meanD3 } from "d3";

export function kernelDensityFunction(data, maximal, minimal) {
  function add(accumulator, a) {
    return accumulator + a;
  }

  const n = data.length;
  const mean = data.reduce((a, b) => a + b) / n;
  const std = Math.sqrt(
    data.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n
  );
  var sorted = data.sort(function(a, b) {
    return a - b;
  });
  const iqr = quantileD3(sorted, 0.75) - quantileD3(sorted, 0.25);
  var smooth = Math.pow(4 / 3 / n, 1 / 5) * Math.min(std, iqr / 1.34);
  var kerDen = [];
  function normDist(x, mu, sigma) {
    return (
      Math.exp((-1 * Math.pow(x - mu, 2)) / 2 / Math.pow(sigma, 2)) /
      sigma /
      Math.sqrt(2 * Math.PI)
    );
  }
  const nKer = 30;
  const step = (maximal - minimal) / (nKer - 1);
  for (var i = 0; i < nKer; i++) {
    kerDen[i] = {
      x: minimal + i * step,
      y: data
        .map(d => normDist(d, minimal + i * step, smooth) / n)
        .reduce(add, 0)
    };
  }
  return kerDen;
}

// https://www.d3-graph-gallery.com/graph/density_basic.html
// Function to compute density
export function kernelDensityEstimator(kernel, X) {
  return function(V) {
    return X.map(function(x) {
      return [
        x,
        meanD3(V, function(v) {
          return kernel(x - v);
        })
      ];
    });
  };
}
export function kernelEpanechnikov(k) {
  return function(v) {
    return Math.abs((v /= k)) <= 1 ? (0.75 * (1 - v * v)) / k : 0;
  };
}
